import { ThumbCheck } from '@/assets/icons/ThumbCheck';
import AppointmentCard from '@/components/appointment/AppointmentCard';
import Hr from '@/components/common/Hr';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { TELEHEALTH_CONTACT_TYPE } from '@/lib/constants';
import type { Appointment } from '@/types/order.type';
import PreparationNotes from '@/views/order/components/PreparationNotes';

interface SelfScheduleConfirmationProps {
  appointment: Appointment;
}

export const SelfScheduleConfirmation = ({ appointment }: SelfScheduleConfirmationProps) => {
  const isPhoneCall = appointment.contactType === TELEHEALTH_CONTACT_TYPE.PHONE;

  return (
    <Card className="gap-6 sm:gap-6">
      <CardHeader>
        <CardTitle className="flex flex-col items-center gap-4">
          <ThumbCheck className="size-15" />
          <h1>You're all set!</h1>
        </CardTitle>
      </CardHeader>

      <CardContent className="space-y-6">
        <p className="text-center">Your Telehealth appointment has been scheduled.</p>

        <div className="space-y-4">
          <CardDescription className="mt-0">
            <p className="font-medium text-orchid-600">Important note</p>
            <p>Patient must be present for Telehealth call</p>
          </CardDescription>
          <Hr className="my-0" />
        </div>

        <AppointmentCard appointment={appointment} isPhoneCall={isPhoneCall} />
        <PreparationNotes />
      </CardContent>
    </Card>
  );
};
